import type {AnchorHTMLAttributes} from 'react';
import type {CSSObject} from '@emotion/react';

import type {QA} from 'common';

export enum LinkVariant {
  Accent = 'accent',
  Blue = 'blue',
}

export type LinkStyles = {
  /** Отключено */
  disabled?: boolean;
  /** Стиль с подчеркиванием */
  isPseudolink?: boolean;
  /** Использовать состояние :visited */
  isVisitable?: boolean;
  /** Показать loader */
  isLoading?: boolean;

  /** Кастомные стили */
  behavior: {
    /** По умолчанию */
    default: CSSObject;
    /** При наведении */
    hover: CSSObject;
    /** При нажатии */
    active: CSSObject;
    /** Был переход по ссылке */
    visited: CSSObject;
    /** Отключенный */
    disabled: CSSObject;
  };
};

export type LinkProps = {
  /** Вариант */
  variant?: LinkVariant;
} & QA &
  Partial<LinkStyles> &
  AnchorHTMLAttributes<HTMLAnchorElement>;
